import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';
import { Button } from './Button';
import { cn } from '../utils/cn';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Close mobile menu on route change
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);
  const navLinks = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'Menu',
    path: '/menu'
  }];
  return <header className={cn('fixed top-0 left-0 right-0 z-50 transition-all duration-300', isScrolled ? 'bg-cream/95 backdrop-blur-md shadow-sm py-4' : 'bg-transparent py-6')} data-id="element-49">
      <div className="container mx-auto px-4 md:px-8 flex items-center justify-between relative" data-id="element-50">
        <Link to="/" className="flex items-center z-50" data-id="element-51">
          <img src="https://cdn.magicpatterns.com/uploads/rDC1PVfnbQ2ypoisaBo9AK/_KITCHEN.png" alt="Radio Africa & Kitchen" className="h-[3.75rem] md:h-[4.375rem] w-auto" data-id="element-52" />
        </Link>

        {/* Centered nav links */}
        <ul className="hidden md:flex items-center gap-10 absolute left-1/2 -translate-x-1/2" data-id="element-53">
          {navLinks.map(link => <li key={link.name} data-id="element-54">
              <Link to={link.path} className={cn('text-sm font-bold uppercase tracking-wider transition-colors hover:text-terracotta relative', location.pathname === link.path ? 'text-terracotta' : link.name === 'Menu' ? 'text-[#7E9B6F]' : 'text-charcoal')} data-id="element-55">
                {link.name}
                {location.pathname === link.path && <motion.div layoutId="nav-indicator" className="absolute -bottom-2 left-0 right-0 h-0.5 bg-terracotta" data-id="element-56" />}
              </Link>
            </li>)}
        </ul>

        {/* Desktop CTA */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-57">
          <div className="flex items-center gap-4" data-id="element-58">
            <Button variant="outline" size="sm" className="border-[#7E9B6F] text-[#7E9B6F] hover:bg-[#7E9B6F] hover:text-charcoal" onClick={() => {
            document.getElementById('inquiry')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} data-id="element-59">
              Inquire Now
            </Button>
          </div>
        </nav>

        {/* Mobile Toggle */}
        <button className="md:hidden z-50 p-2 -mr-2 text-charcoal" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-60">
          {isMobileMenuOpen ? <X size={24} data-id="element-61" /> : <Menu size={24} data-id="element-62" />}
        </button>

        {/* Mobile Menu */}
        <AnimatePresence data-id="element-63">
          {isMobileMenuOpen && <motion.div initial={{
          opacity: 0,
          y: -20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -20
        }} className="fixed inset-0 bg-cream z-40 flex flex-col items-center justify-center pt-20 px-4" data-id="element-64">
              <ul className="flex flex-col items-center gap-8 text-center w-full" data-id="element-65">
                {navLinks.map(link => <li key={link.name} className="w-full" data-id="element-66">
                    <Link to={link.path} className={cn('block py-4 text-3xl font-serif transition-colors', location.pathname === link.path ? 'text-terracotta' : 'text-charcoal')} data-id="element-67">
                      {link.name}
                    </Link>
                  </li>)}
                <li className="w-full mt-8" data-id="element-68">
                  <Button variant="primary" size="lg" className="w-full max-w-xs" onClick={() => {
                setIsMobileMenuOpen(false);
                setTimeout(() => {
                  document.getElementById('inquiry')?.scrollIntoView({
                    behavior: 'smooth'
                  });
                }, 100);
              }} data-id="element-69">
                    Inquire About Catering
                  </Button>
                </li>
              </ul>
            </motion.div>}
        </AnimatePresence>
      </div>
    </header>;
}